import MainMenu from '@/components/foundation/main-menu/MainMenu'
import Client from '@/view/record/client/Client'

export default {
  path: '/client',
  name: 'Client',
  components: {
    default: Client,
    mainMenu: MainMenu
  },
  meta: {
    auth: true,
    mainArea: 'record',
    area: 'record-user',
    breadcrumb: [
      { name: 'Cadastro', link: '/record' },
      { name: 'Cliente' }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/router/record/ClientRoute.js